// extracted by mini-css-extract-plugin
export var colorSquare = "_jv-0";
export var danger = "_jv-5";
export var lightPink = "_jv-8";
export var neutralBlue = "_jv-7";
export var neutralYellow = "_jv-6";
export var normal = "_jv-1";
export var primary = "_jv-2";
export var primaryLight = "_jv-3";
export var solidBlack = "_jv-g";
export var solidGreen = "_jv-b";
export var solidLightBlue = "_jv-d";
export var solidNavy = "_jv-c";
export var solidOrange = "_jv-f";
export var solidPink = "_jv-e";
export var solidRed = "_jv-9";
export var solidYellow = "_jv-a";
export var success = "_jv-4";